<template>
    <div class="row g-0">
        <div class="col-lg-3 col-12" style="display: flex;flex-direction: column;">
<!--             <button class="point_btn" @click="equip_point_type = 'v'" :class="{active: equip_point_type == 'v'}" >電壓：{{equip_point_info["v"]}}<span class="ms-2">V</span></button>
            <button class="point_btn" @click="equip_point_type = 'i'" :class="{active: equip_point_type == 'i'}">電流：{{equip_point_info["i"]}}<span class="ms-2">A</span></button> -->
            <button class="point_btn" @click="equip_point_type = 'p'" :class="{active: equip_point_type == 'p'}">功率：{{equip_point_info["p"]}}<span class="ms-2">W</span></button>
            <!-- <button class="point_btn" @click="equip_point_type = 'f'" :class="{active: equip_point_type == 'f'}">頻率：{{equip_point_info["f"]}}<span class="ms-2">Hz</span></button> -->
            <button class="point_btn" @click="equip_point_type = 'PR'" :class="{active: equip_point_type == 'PR'}">PR：{{equip_point_info["PR"]}}</button>
            <button class="point_btn" @click="equip_point_type = 'DMY'" :class="{active: equip_point_type == 'DMY'}">DMY：{{equip_point_info["DMY"]}}</button>
            <button class="point_btn" @click="equip_point_type = 'kwh'" :class="{active: equip_point_type == 'kwh'}">累計發電量：{{equip_point_info["kwh"]}}<span class="ms-2">kWh</span></button>
            <div class="point_btn_remain"></div>
        </div>
        <plot-zone v-if="equip_point_type !== null" v-bind:ID="plant_ID" v-bind:datatype="equip_point_type" v-bind:collection="'pv_plant'" v-bind:key="equip_point_type"></plot-zone>
    </div>
    
    
</template>

<script>
import PlotZone from "./PlotZone.vue"

export default {
    name: "plant_total_select_zone", 
    props: ["pv_plant_ID"],
    components:{
        PlotZone
    },
    data(){
        return{
            plant_ID: this.$props.pv_plant_ID,
            equip_point_type: null,
            equip_point_info: {},
            equip_point_list: ["p","PR", "DMY", "kwh"], 
        }
    },
    methods:{
        pv_overview(){
            const that = this
            this.axios.get(`/pv_overview?pv_plant_ID_list=${this.plant_ID}`)
            .then(function (data) {
                // 帶入params
                that.equip_point_info = data.data.data[0]
                if(that.equip_point_type === null){
                    for(var i in that.equip_point_list){
                        that.equip_point_type = that.equip_point_list[i]
                        break
                    }
                }
            })
        }
    },
    mounted(){
        this.syncdata = setInterval(this.pv_overview, 5000)
        this.pv_overview()
    },
    destroyed(){
        clearInterval(this.syncdata)
    }
}
</script>
<style src="../../assets/css/PlantInfo.css"></style>

<style>
    .rounded-start{
        border-top-right-radius: .25rem!important;
        border-bottom-right-radius: .25rem!important;
    }
</style>